class Header {
    constructor(el) {
        this.scope = el;
        this.scope.Header = this;
        this.isInline = el.hasAttribute("data-header-inline");
        this.burger = el.querySelector("[data-burger]");
        this.HeaderOpen = false;
        this.primaryLinks = el.querySelectorAll("[data-primary-link]");
        
        this.navContainer = el.querySelector("[data-primary-nav]");
        this.viewport = viewport();
        this.desktopViewport = 3;

        this.handleOutsideClick = (e) => {
            if (!this.navContainer.parentElement.contains(e.target)) {
                this.closeHeader();
                if(this.burger.Burger.burgerOpen){
                    this.burger.Burger.closeBurger();  
                }
                document.removeEventListener('keyup', this.handleOutsideKey);
                document.removeEventListener('click', this.handleOutsideClick);
            }
        }
        this.handleOutsideKey = (e) => {
            if (!this.navContainer.parentElement.contains(e.target) || (e.key === "Escape")) {
                this.closeHeader();
                document.removeEventListener('keyup', this.handleOutsideKey);
                document.removeEventListener('click', this.handleOutsideClick);
            }
        }
        this.bindEvents();
    }

    bindEvents(){
        window.addEventListener("resize", () => {
            const scopeElement = this.scope || document.querySelector('.your-scope-element-selector');

            if (scopeElement) {
               scopeElement.classList.add("header--resizing");
            } else {
                console.error("scopeElement is not defined or not found in the DOM.");
            }
            // close if switch between mobile and desktop or vice versa
            if(
                (this.viewport >= this.desktopViewport && viewport() < this.desktopViewport) ||
                (this.viewport < this.desktopViewport && viewport() >= this.desktopViewport)
            ){
                if(this.HeaderOpen){
                    this.closeHeader()
                }
                this.viewport = viewport();
            }
        });
        
        
        this.burger.addEventListener("click", e => {
            if (this.HeaderOpen) {
                this.closeHeader();
            } else {
                this.openHeader();
            }
        });
        this.primaryLinks.forEach(link =>{
          link.parentElement.addEventListener("open", () => {
                !this.HeaderOpen && this.openHeader();
            });
            link.parentElement.addEventListener("close", () => {
                if (viewport() >= this.desktopViewport && this.isInline) {
                    this.HeaderOpen && this.closeHeader();
                }
            });
        })
    }

    closeHeader(){
        this.scope.classList.add("header--closing");
        this.scope.classList.remove("header--open");
        setTimeout(() => {
            this.scope.classList.remove("header--closing");
        }, 400);
        this.scope.querySelectorAll(".nav--open").forEach(nav => nav.Nav.closeNav());
        document.querySelector("body").classList.remove("overflow-hidden");
        if(this.burger.Burger.burgerOpen){
            this.burger.Burger.closeBurger();
        }
        this.burger.focus();
        this.HeaderOpen = false;
    }

    openHeader(){
        this.scope.classList.add("header--open");
        document.querySelector("body").classList.add("overflow-hidden");
        if(this.scope.querySelector("[data-primary-nav] [data-toggle-nav]")){
            this.scope.querySelector("[data-primary-nav] [data-toggle-nav]").focus();
        }
        setTimeout(()=>{
            document.addEventListener('click', this.handleOutsideClick);
            document.addEventListener('keyup', this.handleOutsideKey);
        }, 100)

        this.HeaderOpen = true;
    }
}

document.querySelectorAll('[data-header]').forEach((el) => {
    new Header(el);
});
